/* lua.js generated code 0.3.0 */

var debugDataRef = false
// RewardItemRef = xClass("RewardItemRef")
// RewardItemRef.prototype.ctor = function (itemId, num) {
//     var self = this
//     self.itemId = itemId || 0
//     self.num = num || 0
// }
// util func ---------------------------------------------------------
let parseItemDictRegex = /\d+:\d+/
function parseItemDict(src) {
    if (!src) {
        return sTable()
    } else if (typeof src === 'object') {
        if (!src.hasOwnProperty("length")) {
            var result = sTable()
            for (const key in src) {
                if (src.hasOwnProperty(key)) {
                    const value = src[key];
                    result.push(
                        {
                            itemId: Number.parseInt(key) || 0,
                            num: value || 0
                        }
                    )
                }
            }
            return result
        }
        return src
    }
    assert(typeof src === "string")
    var result = sTable()
    var items = src.split(',')
    if (items && items.length > 0) {
        for (var i = 0, v = items[0]; v; i++, v = items[i]) {
            var content = v.split(':')
            if (content && content.length > 0) {
                var key = tonumber(content[0])
                var value = tonumber(content[1])
                result.push({
                    itemId: key || 0,
                    num: value || 0
                })
            }
        }
    }
    if (debugDataRef) {
        cc.log("parseItemDict", $len(result))
    }
    return result
}
function parseItemList(src) {
    if (!src) {
        return table()
    }
    assert(typeof src === "string")
    var result = table()
    var items = src.split(",")
    if (items && items.length > 0) {
        for (var i = 0, v = items[0]; v; i++, v = items[i]) {
            result.push(tonumber(v))
        }
    }
    if (debugDataRef) {
        cc.log("parseItemList", $len(result))
    }
    return result
}
function parseConditionRewardList(src) {
    if (typeof src !== "string") {
        return table()
    }
    var result = table()
    var rewards = src.split(";")
    if (rewards) {
        for (var i = 0, v = rewards[0]; v; i++, v = rewards[i]) {
            var reward = RewardsWithConditionRef.new()
            reward.fromLua(v)
            result.push(reward) 
        }
        table.sort(result, function (a, b) {
            return a.condition < b.condition
        })
        for (var index = 1, k = result[1]; k; index++, k = result[index]) {
            k.id = index
        }
    }
    return result
}
parseIngameLimitDict = function (src) {
    if (!src) {
        return table()
    }
    assert(typeof src === "string")
    var result = table()
    var items = src.split(",")
    if (items && items.length > 0) {
        for (var i = 0, v = items[0]; v; i++, v = items[i]) {
            var content = v.split(':')
            if (content && content.length === 4) {
                var key = tonumber(content[0])
                result[key] = {
                    daily: tonumber(content[2]),
                    monthly: tonumber(content[3])
                }
            }
        }
    }
    return result
}
function parseDateTime(timeStr) {
    var timeTable = string.split(timeStr, " ")
    if ($len(timeTable) !== 2) {
        return 0
    }
    var dayTable = string.split(timeTable[1], "-")
    if ($len(dayTable) !== 3) {
        return 0
    }
    var year = tonumber(dayTable[1]) || 0
    var month = tonumber(dayTable[2]) || 0
    var day = tonumber(dayTable[3]) || 0
    var secTable = string.split(timeTable[2], ":")
    if ($len(secTable) !== 3) {
        return 0
    }
    var hour = tonumber(secTable[1]) || 0
    var min = tonumber(secTable[2]) || 0
    var sec = tonumber(secTable[3]) || 0
    // WARN: maybe multi result
    return os.time(table(
        [1, "year", year],
        [1, "month", month],
        [1, "day", day],
        [1, "hour", hour],
        [1, "min", min],
        [1, "sec", sec]
    ))
}
// GlobalServerConfig ---------------------------------------------------------
GlobalServerConfig = xClass("GlobalServerConfig")
GlobalServerConfig.prototype.ctor = function () {
    var self = this
    // self.single_item = 10
    self.ice = 1000
    // self.blocker = 100
    self.collect = 10000
    self.lock = 100
    self.coin = 5
    // self.cuteBall = 100
    // self.crystalBall = 100
    // self.strip = 200
    // self.wrap = 250
    self.color = 300
    // self.mixed_strip_strip = 500
    // self.mixed_wrap_strip = 1000
    // self.mixed_wrap_wrap = 1500
    // self.mixed_color_strip = 2000
    // self.mixed_color_color = 5000
    // self.mixed_wrap_color = 2500
    // self.multiple_wrap = 1
    // self.multiple_strip = 0.5
    // self.multiple_strip_strip = 2
    // self.multiple_color = 1.5
    // self.multiple_wrap_wrap = 3
    // self.multiple_wrap_strip = 2.5
    // self.multiple_color_wrap = 3.5
    // self.multiple_color_strip = 3
    // self.moveTranslateToStrip = 2500
    // self.multiple_color_color = 4
    // self.freeUnlockBagConfig = table(
    //     2,
    //     5,
    //     10,
    //     16,
    //     25,
    //     36
    // )
    // self.translateStripBlast = 200
    // self.compound_strip = 2
    self.initBagSize = 20
    self.daily_max_send_gift_count = 5
    self.daily_max_receive_gift_count = 10
    // self.compound_wrap = 3
    // self.compound_color = 6
    self.user_energy_init_count = 30
    self.user_energy_max_count = 30
    self.invite_friends_count = 20
    // self.invite_friends_continue_day = 60
    // self.user_energy_request_get = 1
    // self.daily_max_request_energy_count = 10
    self.user_energy_recover_time_unit = 480000
    self.user_energy_level_consume = 5
    self.fruit_grow_cycle = 180000
    self.bag_capacity = 10
    // self.time_max_request_energy_receive_count = 5
    self.user_init_coin = 30000
    // self.star_pot_view = table(
    //     0,
    //     18,
    //     36
    // )
    // self.join_QQ_panel_reward = table()
    self.disable_payment = false
    self.fruit_crow_count_num = 5
    // self.promotion_qq_new_user_reward = table()
    self.energy_fruit_ratio = 18
    self.bug_mission_start = 2
    // self.qq_new_user_reward = table()
    self.replace_color_upgrade = 400
    self.digTreasure_play_num = 5
    self.current_digger_match = 1
    self.fillSign = table()
    self.score_game_day = 5
    // self.score_game_reward = table()
    self.enter_invite_code_reward = table()
    self.new_user_reward_normal = table()
    self.shortcut_reward = table()
    self.qzone_background_reward = table()
    // self.new_user_reward_baidu = table()
    // self.new_user_reward_qq = table()
    // self.week_match_levels = table()
    // self.summer_week_match_levels = table()
    self.ingame_limit = table()
    self.ingame_limit_low = table()
    self.new_obstacle_levels = table()
    self.animal_invite_reward_ration = 0.3
    self.animal_invite_rewards = table()
    self.drop_color_limit_level_ids = table()
    self.collect_seed_range = 50
    // self.openRate = 0
    // self.scoreEffectOneRate = 0
    // self.scoreEffectTwoRate = 0
}
GlobalServerConfig.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil of GlobalServerConfig")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (type(v) === "table") {
            var key = v.key
            var value = v[1]
            if (key === "freeUnlockBagConfig" || key === "star_pot_view" || key === "fillSign" || key === "new_obstacle_levels") {
                value = parseItemList(value)
            } else if (key === "daily_first_share_reward" || key === "join_QQ_panel_reward" || key === "score_game_reward" || key === "enter_invite_code_reward" || key === "shortcut_reward" || key === "qzone_background_reward" || key === "new_user_reward_normal" || key === "new_user_reward_baidu" || key === "new_user_reward_qq") {
                value = parseItemDict(value)
            } else if (key === "disable_payment") {
                value = (value === "true")
            } else if (key === "fillSign") {
                var addMarkPrice = table()
                var ss = string.split(value, ",")
                for (var ids = 1, mpi = ss[1]; mpi; ids++, mpi = ss[ids]) {
                    table.insert(addMarkPrice, tonumber(mpi))
                }
                value = addMarkPrice
                cc.log("fillSign", table.tostring(value))
            } else if (key === "week_match_levels") {
                value = parseItemList(value)
            } else if (key === "ingame_limit") {
                value = parseIngameLimitDict(value)
            } else if (key === "ingame_limit_low") {
                value = parseIngameLimitDict(value)
            } else if (key === "animal_invite_rewards") {
                value = parseItemDict(value)
            } else if (key === "daily_max_send_gift_count") {
                var t = string.split(value, ",")
                var ret = table()
                for (var k = 1, v = t[1]; v; k++, v = t[k]) {
                    var s = string.split(v, ":")
                    table.insert(ret, table([1, "level", tonumber(string.split(s[1], "-")[2])], [1, "num", tonumber(s[2])]))
                }
                value = ret
            } else if (key === "beta_user_reward") {
                value = parseItemDict(value)
            } else if (key === "drop_color_limit_level_ids") {
                value = parseItemDict(value)                
            } else {
                value = tonumber(value)
            }
            if (value == null) {
                cc.log("GlobalServerConfig value should not be nil, key=" + key)
            }
            self[key] = value
            if (debugDataRef) {
                cc.log(key, value)
            }
        }
    }
}
GlobalServerConfig.prototype.syncConfig = function (src) {
    let self = this
    // body
    if (src) {
        for (let k in src) {
            let v = src[k]
            if ($null(v)) continue
            if (type(v) === "table") { } else {
                self[k] = tonumber(v)
            }
        }
    }
}
GlobalServerConfig.prototype.getAddMarkPirce = function (addMarkNum) {
    var self = this
    addMarkNum = addMarkNum || 0
    var price = self.fillSign[addMarkNum]
    if (price == null) {
        return 0
    } else {
        return price
    }
}
// MetaRef ---------------------------------------------------------
MetaRef = xClass("MetaRef")
MetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// DiggerMatchGemRewardMetaRef ---------------------------------------------------------
// <diggerMatchGemReward id="1" gemCount="1" rewards="2:100"/> 
DiggerMatchGemRewardMetaRef = xClass("DiggerMatchGemRewardMetaRef", MetaRef)
DiggerMatchGemRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.gemCount = 1
    self.rewards = table()
}
DiggerMatchGemRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at DiggerMatchGemRewardMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// GameModePropMetaRef ---------------------------------------------------------
// <gamemode_prop id="1" gamemode="Classic moves" ingameProps="10001,10010,10002,10003,10005,10004" initProps="10018,10015,10007"/>  
GameModePropMetaRef = xClass("GameModePropMetaRef", MetaRef)
GameModePropMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.gamemode = 0
    self.initProps = table()
    self.ingameProps = table()
    self.finalProps = table()
}
GameModePropMetaRef.prototype.fromLua = function (data) {
    var self = this
    self.id = tonumber(data.id) || 0
    self.gamemode = tonumber(data.gamemode) || 0
    self.initProps = parseItemList(data.initProps || "")
    self.ingameProps = parseItemList(data.ingameProps || "")
    self.finalProps = parseItemList(data.finalProps || "")
}
// HeadFrame ---------------------------------------------------------
//   <head_frame id="1" totalLevel="30"/> 
HeadFrameMetaRef = xClass("HeadFrameMetaRef", MetaRef)
HeadFrameMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.totalLevel = 0
    self.level = 0
    self.main_scene_offset_x = 0
    self.main_scene_offset_y = 0
    self.csb_name = ""
    self.csb_frame = 0
    self.main_scene_offset_scale = 1
}
HeadFrameMetaRef.prototype.fromLua = function (data) {
    var self = this
    self.id = tonumber(data.id) || 0
    if (self.id === 1) { }
    self.totalLevel = tonumber(data.totalLevel) || 0
    self.level = tonumber(data.level) || 0
    self.csb_name = data.csb_name || ""
    self.csb_frame = tonumber(data.csb_frame) || 0
    self.main_scene_offset_x = tonumber(data.main_scene_offset_x) || 0
    self.main_scene_offset_y = tonumber(data.main_scene_offset_y) || 0
    self.main_scene_offset_scale = tonumber(data.main_scene_offset_scale) || 1
}
// CoinBlockerMetaRef ---------------------------------------------------------
// <coin_blocker id="1" coin_amount="50" level="91"/>   
CoinBlockerMetaRef = xClass("CoinBlockerMetaRef", MetaRef)
CoinBlockerMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.coin_amount = 0
    self.level = 0
}
// VipLevelMetaRef ---------------------------------------------------------
// <vip_level id="0" vipExp="10"/>  
VipLevelMetaRef = xClass("VipLevelMetaRef", MetaRef)
VipLevelMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.vipExp = 0
}
// MarketPromotionMetaRef ---------------------------------------------------------
// <market_promotion id="1" condition="1:999" contractId="12345678" rewards="2:100"/> 
MarketPromotionMetaRef = xClass("MarketPromotionMetaRef", MetaRef)
MarketPromotionMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.condition = table()
    self.contractId = 0
    self.rewards = table()
}
MarketPromotionMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at MarketPromotionMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else if (k === "condition") {
            self.condition = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// FreegiftMetaRef ---------------------------------------------------------
// <freegift id="1" item="2:300" topLevel="30"/>  
FreegiftMetaRef = xClass("FreegiftMetaRef", MetaRef)
FreegiftMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.reward = table()
    self.level = 0
    self.maxLevel = 0
}
FreegiftMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at FreegiftMetaRef:fromLua")
        return 
    }
    self.id = tonumber(src.id)
    self.level = tonumber(string.split(src.level,"-")[1])
    self.maxLevel = tonumber(string.split(src.level,"-")[2])
    self.reward = parseItemDict(src.reward)
}
// GoodsMetaRef ---------------------------------------------------------
GoodsMetaRef = xClass("GoodsMetaRef", MetaRef)
GoodsMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.coin = 0
    self.qCoin = 0
    self.qCash = 0
    self.discountQCash = 0
    self.rmb = 0
    self.discountRmb = 0
    self.thirdRmb = 0
    self.discountThird = 0
    self.items = sTable()
    self.level = 0
    self.limit = 0
    self.on = 0
    self.sort = 0
    self.sign = null
    self.online = false
    self.tag = 0
}
GoodsMetaRef.prototype.fromLua = function (data) {
    var self = this
    self.id = tonumber(data.id) || 0
    self.coin = tonumber(data.coin) || 0
    self.qCash = tonumber(data.qCash) || 0
    self.qCoin = tonumber(data.qCoin) || 0
    self.discountQCash = tonumber(data.discountQCash) || 0
    self.rmb = tonumber(data.rmb) || 0
    self.discountRmb = tonumber(data.discountRmb) || 0
    self.thirdRmb = tonumber(data.thirdRmb) || 0
    self.discountThird = tonumber(data.discountThird) || 0
    self.items = parseItemDict(data.items)
    self.level = tonumber(data.level) || 0
    self.limit = tonumber(data.limit) || 0
    self.on = tonumber(data.on) || 0
    self.sort = tonumber(data.sort) || 0
    self.sign = data.sign || null
    self.online = string.lower(tostring(data.online)) === "true"
    self.tag = tonumber(data.tag) || 0
    self.giftbagPropDesc = data.giftbagPropDesc || []
    self.remark = data.remark || ""
    return self
}
GoodsMetaRef.prototype.getCoin = function () {
    var self = this
    return self.coin
}
GoodsMetaRef.prototype.getCash = function () {
    var self = this
    if (self.discountQCash > 0) {
        return self.discountQCash
    } else {
        return self.qCash
    }
}
GoodsMetaRef.prototype.getRmb = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    if (self.discountRmb > 0) {
        return self.discountRmb
    } else if (self.rmb > 0) {
        return self.rmb
    } else {
        TODO("goods id=" + self.id + " rmb price miss.")
        return 0
    }
}
GoodsMetaRef.prototype.getThirdRmb = function () {
    var self = this
    if (self.discountThird > 0) {
        return self.discountThird
    } else {
        return self.thirdRmb
    }
}
// GoodsPayCodeMetaRef ---------------------------------------------------------
// <goodsPayCode id="1" mmPayCode="30000807400101" uniPayCode="140121023049" miPayCode="com.xiaomi.xiaoxiaole.code1" price="3" />
GoodsPayCodeMetaRef = xClass("GoodsPayCodeMetaRef", MetaRef)
GoodsPayCodeMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.props = ""
    self.mmPayCode = ""
    self.mmPayCode_two = ""
    self.mmPayCode_three = ""
    self.uniPayCode = ""
    self.miPayCode = ""
    self.ctPayCode = ""
    self.ctCustomPayCode = ""
    self.price = ""
}
GoodsPayCodeMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at GoodsPayCodeMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "id") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        } else if (type(k) === "string") {
            self[k] = tostring(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// LevelRewardMetaRef ---------------------------------------------------------
LevelRewardMetaRef = xClass("LevelRewardMetaRef", MetaRef)
LevelRewardMetaRef.prototype.ctor = function () {
    var self = this
    // self.id = 0
    // self.failNum = 0
    // self.failTips = 0
    self.levelId = 0
    // self.defaultReward = table()
    // self.newStarReward = table()
    self.guide = false
}

let levelAreaCoinStep = 50
let levelAreaCoinStart = 200
let hideLevelAreaCoinStart = 500
let energyRewardMap = {
    "1" : 0,
    "2" : 2,
    "3" : 3,
    "4" : 5
}
// var defaultRewardNameRef = table(
//     "oneStarDefaultReward",
//     "twoStarDefaultReward",
//     "threeStarDefaultReward",
//     "fourStarDefaultReward"
// )
// var newStarRewardNameRef = table(
//     "oneStarReward",
//     "twoStarReward",
//     "threeStarReward",
//     "fourStarReward"
// )
LevelRewardMetaRef.prototype.fromLua = function (data) {
    var self = this
    // self.id = tonumber(data.id) || 0
    // self.failNum = tonumber(data.failNum) || 0
    // self.failTips = parseItemList(data.failTips)
    self.levelId = tonumber(data.levelId) || 0
    // let $limit88 = $len(defaultRewardNameRef)
    // for (let i = 1; i <= $limit88; i += 1) {
    //     if (type(data[defaultRewardNameRef[i]]) !== "nil") {
    //         table.insert(self.defaultReward, parseItemDict(data[defaultRewardNameRef[i]]))
    //     } else {
    //         break
    //     }
    // }
    // let $limit91 = $len(newStarRewardNameRef)
    // for (let i = 1; i <= $limit91; i += 1) {
    //     if (type(data[newStarRewardNameRef[i]]) !== "nil") {
    //         table.insert(self.newStarReward, parseItemDict(data[newStarRewardNameRef[i]]))
    //     } else {
    //         break
    //     }
    // }
    self.guide = data.guide === "true" || self.guide
}
LevelRewardMetaRef.prototype.getNewStarRewards = function (star, level) {
    var self = this
    level = level || self.levelId
    let levelType = LevelType.getLevelTypeByLevelId(level)
    if (!levelType || (levelType !== GameLevelType.kMainLevel && levelType !== GameLevelType.kHiddenLevel)) {
        return table()
    }
    // let firstLevelArea = MetaManager.getLevelAreaRefByLevelId(1)
    // let currentLevelArea = MetaManager.getLevelAreaRefByLevelId(level)
    // if (!firstLevelArea || !currentLevelArea) {
    //     return table()
    // }
    // let coinReward = levelAreaCoinStart + levelAreaCoinStep * (currentLevelArea.id - firstLevelArea.id)
    let coinReward = calcLevelCoinReward(level, levelType)
    let energyReward = energyRewardMap[star] || 0
    if (levelType === GameLevelType.kHiddenLevel) {
        energyReward = 0
    }
    let rewards = table()
    if (coinReward > 0) {
        rewards.push({
            itemId : GamePropIds.kCoin,
            num    : coinReward
        })
    }
    if (energyReward > 0) {
        rewards.push({
            itemId : GamePropIds.kEnergy,
            num    : energyReward
        })
    }
    return rewards
    // return self.newStarReward[star] || table()
}
function calcLevelCoinReward(levelId, type) {
    if (type === GameLevelType.kMainLevel) {
        return levelAreaCoinStart + levelAreaCoinStep * (Math.floor((levelId - 1) / 30))
    }else {
        return hideLevelAreaCoinStart + levelAreaCoinStep * (Math.floor((levelId - 10001) / 6))
    }
}
LevelRewardMetaRef.prototype.getDefaultRewards = function (level) {
    var self = this
    // let firstLevelArea = MetaManager.getLevelAreaRefByLevelId(1)
    // let currentLevelArea = MetaManager.getLevelAreaRefByLevelId(self.levelId)
    // if (!firstLevelArea || !currentLevelArea) {
    //     return table()
    // }
    level = level || self.levelId
    if (self.guide) {
        return table()
    }
    let levelType = LevelType.getLevelTypeByLevelId(level)
    if (!levelType || (levelType !== GameLevelType.kMainLevel && levelType !== GameLevelType.kHiddenLevel)) {
        return table()
    }
    let coinReward = (calcLevelCoinReward(level, levelType)) / 10
    let rewards = table()
    if (coinReward > 0) {
        rewards.push({
            itemId : GamePropIds.kCoin,
            num    : coinReward
        })
    }
    return rewards
    // return self.defaultReward[star] || table()
}
// InviteRewardMetaRef ---------------------------------------------------------
// <invite_reward id="1" condition="0:1" rewards="2:500"/>  
InviteRewardMetaRef = xClass("InviteRewardMetaRef", MetaRef)
InviteRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.condition = 0
    self.rewards = table()
}
InviteRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at InviteRewardMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// InviteCountRewardMetaRef ---------------------------------------------------------
// <invite_reward id="1" condition="0:1" rewards="2:500"/>  
InviteCountRewardMetaRef = xClass("InviteCountRewardMetaRef", MetaRef)
InviteCountRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.count = table()
    self.rewards = table()
}
InviteCountRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at InviteCountRewardMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// LevelMetaRef ---------------------------------------------------------
// <level id="1" exp="10"/>  
LevelMetaRef = xClass("LevelMetaRef", MetaRef)
LevelMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.exp = 0
}
// QgameVipDailyRewardMetaRef ---------------------------------------------------------
// <qq_game_vip_daily_reward id="1" reward="10012:2,2:1000" type="1" vipLevel="1"/>  
QgameVipDailyRewardMetaRef = xClass("QgameVipDailyRewardMetaRef", MetaRef)
QgameVipDailyRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.reward = table()
    self.type = 0
    self.vipLevel = 0
}
QgameVipDailyRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at QgameVipDailyRewardMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "reward") {
            self.reward = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// DecoMetaRef ---------------------------------------------------------
// <deco id="20001" type="1"/> 
DecoMetaRef = xClass("DecoMetaRef", MetaRef)
DecoMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.type = 0
}
// LevelAreaMetaRef ---------------------------------------------------------
// <level_area id="40001" maxLevel="15" minLevel="1" star="0"/>  
LevelAreaMetaRef = xClass("LevelAreaMetaRef", MetaRef)
LevelAreaMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.maxLevel = 0
    self.minLevel = 0
    self.star = 0
    self.coolDown = 0
}
LevelAreaMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.id = tonumber(src.id) || 0
    self.maxLevel = tonumber(src.maxLevel) || 0
    self.minLevel = tonumber(src.minLevel) || 0
    self.star = tonumber(src.star) || 0
    self.coolDown = tonumber(src.coolDown) || 0
    self.newItems = table()
    if (src.newItems) {
        var list = string.split(src.newItems, ",")
        for (var k = 1, v = list[1]; v; k++, v = list[k]) {
            self.newItems[k] = tonumber(v)
        }
    }
}
// FuncMetaRef ---------------------------------------------------------
// <func id="30001" type="1"/>  
FuncMetaRef = xClass("FuncMetaRef", MetaRef)
FuncMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.type = 0
}
// FruitsMetaRef ---------------------------------------------------------
// <fruits id="1" level="1" reward="2:1150,4:1" upgrade="100"/>  
FruitsMetaRef = xClass("FruitsMetaRef", MetaRef)
FruitsMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.level = 0
    self.reward = table()
    self.upgrade = 0
}
FruitsMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at FruitsMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "reward") {
            self.reward = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// MarkMetaRef ---------------------------------------------------------
// <mark id="1" rewards="2:1000" type="1"/>  
MarkMetaRef = xClass("MarkMetaRef", MetaRef)
MarkMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.type = 1
    self.rewards = table()
    self.raw_rewards = ""
    self.goodsId = 0
}
MarkMetaRef.prototype.fromLua = function (data) {
    var self = this
    self.id = tonumber(data.id) || 0
    self.type = tonumber(data.type) || 1
    self.rewards = parseItemDict(data.rewards)
    self.raw_rewards = tostring(data.rewards) || ""
    self.goodsId = tonumber(data.goodsId || 0)
    return self
}
// AchiMetaRef ---------------------------------------------------------
// <achi id="1" type="3"/>  
AchiMetaRef = xClass("AchiMetaRef", MetaRef)
AchiMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.type = 0
}
// DiggerMatchRankRewardMetaRef ---------------------------------------------------------
// <digger_match_rank_reward id="1" maxRange="1" minRange="1" rewards="2:100"/> 
DiggerMatchRankRewardMetaRef = xClass("DiggerMatchRankRewardMetaRef", MetaRef)
DiggerMatchRankRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.maxRange = 0
    self.minRange = 0
    self.rewards = table()
}
DiggerMatchRankRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at DiggerMatchRankRewardMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// DiggerMatchGemRewardMetaRef ---------------------------------------------------------
// <digger_match_gem_reward id="1" gemCount="1" rewards="2:100"/> 
//jDiggerMatchGemRewardMetaRef = class("--jDiggerMatchGemRewardMetaRef", DiggerMatchRankRewardMetaRef)
//jfunction DiggerMatchGemRewardMetaRef:ctor()
//j	self.id = 0
//j	self.gemCount = 0
//j	self.rewards = {}
//jend
// FruitsUpgradeMetaRef ---------------------------------------------------------
// <fruits_upgrade id="3" coin="120000" level="3" lock="false" pickCount="4" plus="50" upgradeCondition="2:2"/>  
FruitsUpgradeMetaRef = xClass("FruitsUpgradeMetaRef", MetaRef)
FruitsUpgradeMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.coin = 0
    self.level = 0
    self.lock = false
    self.pickCount = 0
    self.plus = 0
    self.upgradeCondition = table()
}
FruitsUpgradeMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at FruitsUpgradeMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "upgradeCondition") {
            self.upgradeCondition = parseItemDict(v)
        } else if (k === "lock") {
            self.lock = (v === "true")
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// QqVipDailyRewardMetaRef ---------------------------------------------------------
// <qq_vip_daily_reward id="1" reward="10012:1,2:500" type="1" vipLevel="1"/>  
QqVipDailyRewardMetaRef = xClass("QqVipDailyRewardMetaRef", MetaRef)
QqVipDailyRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.reward = table()
    self.type = 0
    self.vipLevel = 0
}
QqVipDailyRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at QqVipDailyRewardMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "reward") {
            self.reward = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// StarRewardMetaRef ---------------------------------------------------------
// <star_reward id="1" reward="10013:2" starNum="24"/>  
// StarRewardMetaRef = class("StarRewardMetaRef", MetaRef)
// function StarRewardMetaRef:ctor()
// 	self.id = 0
// 	self.reward = {}
// 	self.starNum = 0
// end
// function StarRewardMetaRef:fromLua( src )
// 	if not src then
// 		print("  [WARNING] lua data is nil at StarRewardMetaRef:fromLua")
// 		return
// 	end
// 	for k,v in pairs(src) do
// 		if k == "reward" then
// 			self.reward = parseItemDict(v)
// 		else 
// 			if type(k) == "string" then
// 				self[k] = tonumber(v)
// 				if debugDataRef then print(k, v) end
// 			end
// 		end
// 	end
// end
// DiscountNotifyMetaRef ---------------------------------------------------------
// <discount_notify id="1" conditions="1:3,2:2" goods="37:7" mode="2"/>  
DiscountNotifyMetaRef = xClass("DiscountNotifyMetaRef", MetaRef)
DiscountNotifyMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.conditions = table()
    self.goods = table()
    self.mode = 0
}
DiscountNotifyMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at DiscountNotifyMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "conditions") {
            self.conditions = parseItemDict(v)
        } else if (k === "goods") {
            self.goods = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// GiftBlockerMetaRef ---------------------------------------------------------
// <gift_blocker id="5" level="10013" prop_id="10026,10025"/> 
GiftBlockerMetaRef = xClass("GiftBlockerMetaRef", MetaRef)
GiftBlockerMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.prop_id = table()
    self.level = 0
}
GiftBlockerMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at GiftBlockerMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "prop_id") {
            self.prop_id = parseItemList(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// HideAreaMetaRef ---------------------------------------------------------
// <hide_area id="1" continueLevels="1-44" hideAreaId="0" hideLevelRange="1-3"/>  
HideAreaMetaRef = xClass("HideAreaMetaRef", MetaRef)
HideAreaMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.level = null
    self.range = null
    self.rewards = null
}
function parseHideAreaLevel(src) {
    if (!src) {
        return table()
    }
    assert(type(src) === "string")
    var content = string.split(src, "-")
    var beginNum = tonumber(content[1])
    var endNum = tonumber(content[2])
    var result = table()
    let $var147 = beginNum,$limit148 = endNum
    for (let i = $var147; i <= $limit148; i += 1) {
        table.insert(result, 10000 + i)
    }
    return result
}
HideAreaMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at HideAreaMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else if (k === "range") {
            self.range = parseHideAreaLevel(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// LadybugRewardMetaRef ---------------------------------------------------------
// <ladybug_reward id="1" goalType="1:12" missionReward="2:3000,10013:2" timeLimit="24"/>  
LadybugRewardMetaRef = xClass("LadybugRewardMetaRef", MetaRef)
LadybugRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.goalType = table()
    self.missionReward = table()
    self.timeLimit = 0
}
LadybugRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("  [WARNING] lua data is nil at LadybugRewardMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "goalType") {
            self.goalType = parseItemDict(v)
        } else if (k === "missionReward") {
            self.missionReward = parseItemDict(v)
        } else if (type(k) === "string") {
            self[k] = tonumber(v)
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
}
// PropMetaRef ---------------------------------------------------------
PropMetaRef = xClass("PropMetaRef", MetaRef)
PropMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.expireTime = 0
    self.type = false
    self.maxUsetime = 0
    self.reward = 0
    self.sell = 0
    self.unlock = 0
    self.useable = false
    self.value = 0
    self.propMode = 0
    self.price = 0
    self.rewardList = table()
    self.displayPrice = null
    self.fixedExpireTime = null
    self.propName = ""
    self.expireType = ""
}
PropMetaRef.prototype.fromLua = function (src) {
    var self = this
    src = src || table()
    self.id = tonumber(src.id) || self.id
    self.expireTime = tonumber(src.expireTime) || self.expireTime
    self.type = src.type || self.type
    self.maxUsetime = tonumber(src.maxUsetime) || self.maxUsetime
    self.reward = tonumber(src.reward) || self.reward
    self.sell = tonumber(src.sell) || self.sell
    self.unlock = tonumber(src.unlock) || self.unlock
    self.useable = src.useable || self.useable
    self.value = tonumber(src.value) || self.value
    self.propMode = tonumber(src.propMode) || self.propMode
    self.price = tonumber(src.price) || self.price
    self.rewardList = parseItemDict(src.rewardList) || self.rewardList
    self.displayPrice = src.displayPrice
    if (src.fixedExpireTime && src.fixedExpireTime != "")self.fixedExpireTime = src.fixedExpireTime
    self.propName = src.propName
    self.expireType = src.expireType
}
// ProductMetaRef ---------------------------------------------------------
// <product id="1" cash="60" productId="com.happyelements.animal.gold.cn.1" discount="10"/>
ProductMetaRef = xClass("ProductMetaRef", MetaRef)
ProductMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.cash = 0
    self.extraCash = 0
    self.productId = ""
    self.show = 0
    self.price = 0
    self.firstPay = 0
    self.itemKey = null
    self.giftBagId = 0
    self.subtype = ""
    discount = 10
}
ProductMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("\t\t[WARNING] lua data is nil at ProductMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "productId") {
            self.productId = v
        } else if (k === "tag") {
            self.tag = v
        } else if (k === "itemKey") {
            self.itemKey = v
        } else if (k === "title") {
            self.title = v
        } else if (k === "label") {
            self.label = v
        } else if (k === "subtype") {
            self.subtype = v
        } else {
            if (type(k) === "string") {
                if (v.length < 1) {
                    self[k] = 0
                } else {
                    self[k] = tonumber(v)
                }
            }
            if (debugDataRef) {
                cc.log(k, v)
            }
        }
    }
    return self
}
ProductMetaSubClassRef = xClass("ProductMetaSubClassRef", ProductMetaRef)
ProductMetaSubClassRef.prototype.ctor = function () {
    var self = this
    ProductMetaRef.prototype.ctor.call(self)
}
ProductMetaSubClassRef.prototype.fromLua = function (src) {
    let self = this
    let tmpRef = ProductMetaRef.create()
    tmpRef.fromLua(src)
    // let parentProductRef = MetaManager.getProductMetaByID(tmpRef.id)
    let parentProductRef = MetaManager.getBaseProductMetaByID(tmpRef.id)
    if (!parentProductRef) {
        cc.warn(`product not exist, id = ${tmpRef.id}`)
        parentProductRef = tmpRef
    }
    for (var k in parentProductRef) {
        if (parentProductRef[k] && type(parentProductRef[k]) === "function") {
            continue
        }
        if (!tmpRef[k] || tmpRef[k] === "") {
            self[k] = parentProductRef[k]
        }else {
            self[k] = tmpRef[k]
        }
    }
}
MarketConfigRef = xClass("MarketConfigRef", MetaRef)
MarketConfigRef.prototype.ctor = function () {
    var self = this
    self.goods = table()
    self.id = 0
    self.textKey = ""
}
MarketConfigRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("\t\t[WARNING] lua data is nil at MarketConfigRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "id") {
            self.id = tonumber(v)
        } else if (k === "textKey") {
            self.textKey = v
        } else if (type(v) === "table") {
            table.insert(self.goods, tonumber(v.id))
        }
    }
}
CnValentineMetaRef = xClass("CnValentineMetaRef", MetaRef)
CnValentineMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("\t\t[WARNING] lua data is nil at MarketConfigRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "id") {
            self.id = tonumber(v)
        } else if (k === "num") {
            self.num = tonumber(v)
        } else if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else {
            self[k] = v
        }
    }
}
ActivityRewardsMetaRef = xClass("ActivityRewardsMetaRef", MetaRef)
ActivityRewardsMetaRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        cc.log("\t\t[WARNING] lua data is nil at ActivityRewardsMetaRef:fromLua")
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else {
            self[k] = v
        }
    }
}
RewardsRef = xClass("RewardsRef", MetaRef)
RewardsRef.prototype.fromLua = function (src) {
    var self = this
    if (!src) {
        return 
    }
    for (var k in src) {
        var v = src[k]
        if (k === "rewards") {
            self.rewards = parseItemDict(v)
        } else {
            self[k] = tonumber(v)
        }
    }
}
RewardsWithConditionRef = xClass("RewardsWithConditionRef", MetaRef)
RewardsWithConditionRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.condition = 0
    self.items = table()
}
RewardsWithConditionRef.prototype.fromLua = function (src) {
    var self = this
    if (type(src) === "string") {
        var vals = string.split(src, "=")
        var condition = 0
        var items = table()
        if ($len(vals) > 1) {
            condition = tonumber(vals[1])
            items = parseItemDict(vals[2])
        } else if ($len(vals) === 1) {
            items = parseItemDict(vals[1])
        }
        self.condition = condition
        self.items = items
    }
}
LevelStatusRef = xClass("LevelStatusRef", MetaRef)
NewUserRewardMetaRef = xClass("NewUserRewardMetaRef", MetaRef)
NewUserRewardMetaRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.id = 0
    self.beginTime = 0
    self.endTime = 0
    self.platform = table()
    self.rewardItems = table()
}
NewUserRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.id = src.id || 0
    self.beginTime = parseDateTime(src.begin)
    self.endTime = parseDateTime(src.end)
    self.platform = string.split(src.platform, ",")
    self.rewardItems = parseItemDict(src.rewards)
}
PropMaxUseMetaRef = xClass("PropMaxUseMetaRef", MetaRef)
PropMaxUseMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.levelIdStart = 0
    self.levelIdEnd = 0
    self.maxUseTime = table()
}
PropMaxUseMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.id = tonumber(src.id) || 0
    self.levelIdStart = tonumber(src.levelIdstart) || 0
    self.levelIdEnd = tonumber(src.levelIdend) || 0
    self.maxUseTime = parseItemDict(src.maxUsetime)
    return self
}
GuidePropMetaRef = xClass("GuidePropMetaRef", MetaRef)
GuidePropMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.reward = table()
}
GuidePropMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.id = tonumber(src.id) || 0
    self.reward = parseItemDict(src.reward)
    return self
}
FriendCouponMetaRef = xClass("FriendCouponMetaRef", MetaRef)
FriendCouponMetaRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.id = 0
    self.reward = table()
    self.type = 0
    self.value = 0
}
FriendCouponMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.id = tonumber(src.id) || 0
    self.reward = parseItemDict(src.reward)
    self.type = tonumber(src.type)
    self.value = tonumber(src.value)
}

StarRewardMetaRef = xClass("StarRewardMetaRef", MetaRef)
StarRewardMetaRef.prototype.ctor = function () {
    var self = this
    self.id = 0
    self.rewards = table()
    self.raw_rewards = ""
    self.starNum = tonumber(self.starNum)
}
StarRewardMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.id = tonumber(src.id) || 0
    self.rewards = parseItemDict(src.rewards) || table()
    self.raw_rewards = tostring(src.rewards) || ""
    self.starNum = tonumber(src.starNum) || 0
    return self
}
IntroMetaRef = xClass("IntroMetaRef", MetaRef)
IntroMetaRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.id = 0
    self.itemId = 10001
    self.sort = 0
    self.category = 0
    self.unlockLevel = 0
}
IntroMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.id = tonumber(src.id) || 0
    self.itemId = tonumber(src.itemId) || 10001
    self.sort = tonumber(src.sort) || 0
    self.category = tonumber(src.category) || 0
    self.unlockLevel = tonumber(src.unlockLevel) || 0
}
MaintenanceMetaRef = xClass("MaintenanceMetaRef", MetaRef)
MaintenanceMetaRef.prototype.ctor = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.enable = false
    self.id = 0
    self.name = ""
    self.uid = 0
    self.level = 0
    self.export = false
}
MaintenanceMetaRef.prototype.fromLua = function (src) {
    var self = this
    self.enable = string.lower(tostring(src.enable)) === "true"
    self.value = src.value
    self.id = src.id
    self.name = src.name
    self.beginDate = src.beginDate
    self.endDate = src.endDate
    self.uid = tonumber(src.uid) || 0
    self.level = tonumber(src.level) || 0
    self.version = src.version
    self.platform = src.platform
    self.export = src.export
}
//Promotion 
AppPromRef = xClass("AppPromRef", MetaRef)
AppPromRef.prototype.ctor = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    self.id = 0
    self.order = 0
    self.rewards = table()
    self.panelImg = ""
    self.iosOpen = false
    self.androidOpen = false
    self.iosVersionMin = 0.0
    self.iosVersionMax = 99.99
    self.androidVersionMin = 0.0
    self.androidVersionMax = 99.99
    self.gameVersionMin = "1.0"
    self.gameVersionMax = "9999.99"
    self.startTime = 0
    self.endTime = 1735664461000
    self.uidStart = 0
    self.uidEnd = 99
    self.levelMin = 0
    self.levelMax = 999
    self.recentPayAmountMax = 999
    self.registerDays = 999
    self.dailyPopOutTimes = 1
    self.totalPopOutTimes = 1
    self.order = 0
    self.finishType = 1
    self.getRewardType = 1
    self.androidUrl = ""
    self.androidSchemeBase = ""
    self.androidBundleIds = ""
    self.iosBundleName = ""
    self.iosUrl = ""
    self.iosSchemeBase = ""
    self.channelId = ""
    self.noRewardCloseType = 0
    self.panelImg = ""
    self.triggers = table()
    self.popoutInstalled = false
}
AppPromRef.prototype.fromLua = function (src) {
    let self = this
    self.id = src.id
    self.appName = src.appName
    if (src.triggers) {
        if (type(src.triggers) === "table") {
            self.triggers = src.triggers
        } else {
            let tmpArray = string.split(src.triggers, ";")
            for (let _ in tmpArray) {
                let trigger = tmpArray[_]
                if ($null(trigger)) continue
                if (trigger != null && trigger != "") {
                    let tmp = string.split(trigger, ",")
                    let tType = tonumber(tmp[1])
                    table.remove(tmp, 1)
                    self.triggers[tType] = tmp
                }
            }
        }
    }
    if (src.phoneOs === 0) {
        self.iosOpen = true
        self.androidOpen = true
    } else if (src.phoneOs === 1) {
        self.iosOpen = true
    } else if (src.phoneOs === 2) {
        self.androidOpen = true
    }
    self.iosVersionMin = tonumber(src.iosVersionMin) || 0
    self.iosVersionMax = tonumber(src.iosVersionMax) || 9999
    self.androidVersionMax = tonumber(src.androidVersionMax) || 9999
    self.androidVersionMin = tonumber(src.androidVersionMin) || 0
    self.gameVersionMax = src.gameVersionMax || "9999.99"
    self.gameVersionMin = src.gameVersionMin || "1.0"
    self.startTime = tonumber(src.startTime) || 0
    self.endTime = tonumber(src.endTime) || 1735664461000
    self.uidStart = tonumber(src.uidStart) || 0
    self.uidEnd = tonumber(src.uidEnd) || 99
    self.levelMax = tonumber(src.levelMax) || 9999
    self.levelMin = tonumber(src.levelMin) || -1
    self.recentPayAmountMax = tonumber(src.recentPayAmountMax) || 0
    self.registerDays = tonumber(src.registerDays) || 0
    self.dailyPopOutTimes = tonumber(src.dailyPopOutTimes) || 1
    self.totalPopOutTimes = tonumber(src.totalPopOutTimes) || 1
    self.order = tonumber(src.order) || 0
    self.finishType = tonumber(src.finishType) || 0
    self.getRewardType = tonumber(src.getRewardType) || 0
    if (src.rewards) {
        if (type(src.rewards) === "table") {
            self.rewards = src.rewards
        } else {
            self.rewards = parseItemDict(src.rewards) || table()
        }
    }
    self.androidUrl = src.androidUrl
    self.androidSchemeBase = src.androidSchemeBase
    if (src.androidBundleIds) {
        if (type(src.androidBundleIds) === "table") {
            self.androidBundleIds = src.androidBundleIds
        } else {
            self.androidBundleIds = string.split(src.androidBundleIds || "", ",")
        }
    }
    self.iosUrl = src.iosUrl
    self.iosSchemeBase = src.iosSchemeBase
    self.iosBundleName = src.iosBundleName
    self.channelId = src.channelId
    self.noRewardCloseType = tonumber(src.noRewardCloseType) || 0
    self.panelImg = src.panelImg
    self.popoutInstalled = src.popoutInstalled
    return self
}
AppPromRef.prototype.encode = function () {
    let self = this
    let data = table()
    for (let k in self) {
        let v = self[k]
        if ($null(v)) continue
        if (k === "class") {
            // do nothing.
        } else if (type(v) === "function") {
            // do nothing.
        } else if (k === "rewards") {
            let strs = table()
            for (let i = 1, w = v[1]; w; i++, w = v[i]) {
                table.insert(strs, string.format("%d:%d", w.itemId, w.num))
            }
            data.rewards = table.concat(strs, ",")
        } else if (k === "triggers") {
            let strs = table()
            for (let l in v) {
                let w = v[l]
                if ($null(w)) continue
                table.insert(strs, string.format("%d,%s", l, table.concat(w, ",")))
            }
            data.triggers = table.concat(strs, ";")
        } else {
            data[k] = v
        }
    }
    return data
}
WechatShareAppId = xClass("WechatShareAppId", MetaRef)
WechatShareAppId.prototype.ctor = function () {
    let self = this
    self.id = 0
    self.platform = ""
    self.wxId = ""
}
WechatShareAppId.prototype.fromLua = function (src) {
    let self = this
    self.id = tonumber(src.id) || 0
    self.platform = src.platform || ""
    self.wxId = src.wxId || ""
}

IconMeta = xClass("IconMeta")
IconMeta.prototype.fromLua = function (src) {
    let self = this
    if (!src) {
        return 
    }
    self.id = tonumber(src.id)
    self.name = src.name
    self.order = tonumber(src.order)
    self.visible = tonumber(src.visible)
}
LabelsMeta = xClass("LabelsMeta")
LabelsMeta.prototype.ctor = function () {
    let self = this
    self.id = 0
    self.type = 0
    self.label = 0
    self.min = 0
    self.max = 0
}
LabelsMeta.prototype.fromLua = function (src) {
    let self = this
    if (!src) {
        return 
    }
    self.id = tonumber(src.id) || 0
    self.type = tonumber(src.type) || 0
    self.label = tonumber(src.label) || 0
    self.min = tonumber(src.min) || 0
    self.max = tonumber(src.max) || 0
    return self
}
DynamicGiftMeta = xClass("DynamicGiftMeta")
DynamicGiftMeta.prototype.ctor = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    self.id = 0
    self.type = 0
    self.rmbPay = 0
    self.goodsId = 0
    self.buyTime = 0
    self.buyNumLimit = 0
    self.buyCDTime = 0
    self.notBuyCDTime = 0
    self.preId = 0
}
DynamicGiftMeta.prototype.fromLua = function (data) {
    let self = this
    self.id = tonumber(data.id) || 0
    self.type = tonumber(data.type) || 0
    self.rmbPay = tonumber(data.rmbPay) || 0
    self.goodsId = tonumber(data.goodsId) || 0
    self.buyTime = tonumber(data.buyTime) || 0
    self.buyNumLimit = tonumber(data.buyNumLimit) || 0
    self.buyCDTime = tonumber(data.buyCDTime) || 0
    self.notBuyCDTime = tonumber(data.notBuyCDTime) || 0
    self.preId = tonumber(data.preId) || 0
}
LevelHardnessMeta = xClass("LevelHardnessMeta")
LevelHardnessMeta.prototype.ctor = function () {
    let self = this
    self.id = 0
    self.difficulty = 0
}
LevelHardnessMeta.prototype.fromLua = function (src) {
    let self = this
    if (!src) {
        return 
    }
    self.id = tonumber(src.id) || 0
    self.difficulty = tonumber(src.difficulty) || 0
    return self
}
DifficultyControlColorEffect = xClass("DifficultyControlColorEffect", MetaRef)
DifficultyControlColorEffect.prototype.ctor = function () {
    let self = this
    //---------------------
    //startegy 策略类型
    //totalColor 存在颜色总数
    //effectColor 干预颜色数
    //effectProb  干预概率 （0-100）
    //----------------------
    self.id = 0
    self.effectColor = 0
    self.effectProb = 0
    self.startegy = 0
    self.totalColor = 0
}
// 掉落优化配置
DropAdjustMetaRef = xClass("DropAdjustMetaRef", MetaRef)
DropAdjustMetaRef.prototype.ctor = function () {
    let self = this
    self.drop_adjust_percent_weak = 0
    self.drop_adjust_single_mn_weak = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_weak = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_percent_normal = 0
    self.drop_adjust_single_mn_normal = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_normal = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_percent_strong = 0
    self.drop_adjust_single_mn_strong = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_strong = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_percent_fuuu = 0
    self.drop_adjust_single_mn_fuuu = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_percent = 0
    self.fuuu_stop_left_steps = 0
    self.fuuu_stop_target_num = table()
    self.drop_adjust_test_group = table()
    self.drop_adjust_index = table()
    self.drop_adjust_percent_weak_new = 0
    self.drop_adjust_single_mn_weak_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_weak_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_percent_normal_new = 0
    self.drop_adjust_single_mn_normal_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_normal_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_percent_strong_new = 0
    self.drop_adjust_single_mn_strong_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_strong_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_percent_extreme_new = 0
    self.drop_adjust_single_mn_extreme_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_extreme_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_percent_fuuu_new = 0
    self.drop_adjust_single_mn_fuuu_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu_new = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_percent_new = 0
    self.fuuu_stop_left_steps_new = 0
    self.fuuu_stop_target_num_new = table()
    self.drop_adjust_percent_fuuu_strong_new = 0
    self.drop_adjust_single_mn_fuuu_strong_new = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu_strong_new = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_percent_strong_new = 0
    self.fuuu_stop_target_num_strong_new = table()
    self.fuuu_stop_left_steps_strong_new = 0
    self.drop_adjust_percent_fuuu_counterV2 = 0
    self.drop_adjust_single_mn_fuuu_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_percent_counterV2 = 0
    self.target_complete_expect_k_counterV2 = 0
    self.fuuu_stop_left_steps_counterV2 = 0
    self.fuuu_stop_target_num_counterV2 = table()
    self.fuuu_completion_counterV2 = table()
    self.drop_adjust_percent_fuuu_strong_counterV2 = 0
    self.drop_adjust_single_mn_fuuu_strong_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu_strong_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_percent_strong_counterV2 = 0
    self.target_complete_expect_k_strong_counterV2 = 0
    self.fuuu_stop_target_num_strong_counterV2 = table()
    self.fuuu_stop_left_steps_strong_counterV2 = 0
    self.fuuu_completion_strong_counterV2 = table()
    self.drop_adjust_index_new = table()
    self.active_7daysTag_duration_new = 0
    self.active_30daysTag_duration_new = 0

    self.mainLevel_retry_dataNum = 0
    self.adv_level_dataNum = 0
    self.ship_level_dataNum = 0
    self.drop_adjust_percent_fuuu_negative_counterV2 = 0
    self.drop_adjust_single_mn_fuuu_negative_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu_negative_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_k_negative_counterV2 = 0
    self.fuuu_stop_target_num_negative_counterV2 = table()
    self.fuuu_completion_negative_counterV2 = table()
    self.fuuu_stop_left_steps_negative_counterV2 = 0
    self.drop_adjust_percent_fuuu_balance1_counterV2 = 0
    self.drop_adjust_single_mn_fuuu_balance1_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu_balance1_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_k_balance1_start_counterV2 = 0
    self.target_complete_expect_k_balance1_end_counterV2 = 0
    self.drop_adjust_percent_fuuu_balance2_counterV2 = 0
    self.drop_adjust_single_mn_fuuu_balance2_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.drop_adjust_fullscreen_mn_fuuu_balance2_counterV2 = table([1, "m", 0], [1, "n", 0])
    self.target_complete_expect_k_balance2_start_counterV2 = 0
    self.target_complete_expect_k_balance2_end_counterV2 = 0
    self.fuuu_stop_target_num_balance_counterV2 = table()
    self.fuuu_completion_balance_counterV2 = table()
    self.fuuu_stop_left_steps_balance_counterV2 = 0
}
DropAdjustMetaRef.prototype.fromLua = function (src) {
    let self = this
    let DASchemeConfig = require("clover/config/userTag/DASchemeConfig")
    for (let _ = 1, v = src[1]; v; _++, v = src[_]) {
        let [key, value] = [v.nameKey, v.value]
        if (key === "drop_adjust_percent_weak") {
            self.drop_adjust_percent_weak = tonumber(value)
            DASchemeConfig.Scheme_Week.probability = self.drop_adjust_percent_weak
        } else if (key === "drop_adjust_single_mn_weak") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_weak = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_Week.dropPort.single = self.drop_adjust_single_mn_weak
        } else if (key === "drop_adjust_fullscreen_mn_weak") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_weak = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_Week.dropPort.global = self.drop_adjust_fullscreen_mn_weak
        } else if (key === "drop_adjust_percent_normal") {
            self.drop_adjust_percent_normal = tonumber(value)
            DASchemeConfig.Scheme_Normal.probability = self.drop_adjust_percent_normal
        } else if (key === "drop_adjust_single_mn_normal") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_normal = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_Normal.dropPort.single = self.drop_adjust_single_mn_normal
        } else if (key === "drop_adjust_fullscreen_mn_normal") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_normal = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_Normal.dropPort.global = self.drop_adjust_fullscreen_mn_normal
        } else if (key === "drop_adjust_percent_strong") {
            self.drop_adjust_percent_strong = tonumber(value)
            DASchemeConfig.Scheme_Strong.probability = self.drop_adjust_percent_strong
        } else if (key === "drop_adjust_single_mn_strong") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_strong = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_Strong.dropPort.single = self.drop_adjust_single_mn_strong
        } else if (key === "drop_adjust_fullscreen_mn_strong") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_strong = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_Strong.dropPort.global = self.drop_adjust_fullscreen_mn_strong
        } else if (key === "drop_adjust_percent_fuuu") {
            self.drop_adjust_percent_fuuu = tonumber(value)
            DASchemeConfig.Scheme_fuuu.probability = self.drop_adjust_percent_fuuu
        } else if (key === "drop_adjust_single_mn_fuuu") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_fuuu.dropPort.single = self.drop_adjust_single_mn_fuuu
        } else if (key === "drop_adjust_fullscreen_mn_fuuu") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
            DASchemeConfig.Scheme_fuuu.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu
        } else if (key === "target_complete_expect_percent") {
            self.target_complete_expect_percent = tonumber(value)
            DASchemeConfig.Scheme_fuuu.fuuu.expectRatio = self.target_complete_expect_percent
        } else if (key === "fuuu_stop_left_steps") {
            self.fuuu_stop_left_steps = tonumber(value)
            DASchemeConfig.Scheme_fuuu.fuuu.stopLeftSteps = self.fuuu_stop_left_steps
        } else if (key === "fuuu_stop_target_num") {
            let list = string.split(value, ",")
            let $limit800 = $len(list)
            for (let i = 1; i <= $limit800; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num[key] = tonumber(list2[2])
                DASchemeConfig.Scheme_fuuu.fuuu.stopTargetNum[key] = self.fuuu_stop_target_num[key]
            }
        } else if (key === "drop_adjust_test_group") {
            let list = string.split(value, "]")
            let $limit806 = $len(list)
            for (let i = 1; i < $limit806; i += 1) {
                let str = list[i]
                if (string.starts(str, ",")) {
                    str = string.sub(str, 2, $len(str))
                }
                let list2 = string.split(str, ":")
                let k = list2[1]
                self.drop_adjust_test_group[k] = table()
                let vs = string.sub(list2[2], 2, $len(list2[2]))
                let list3 = string.split(vs, ",")
                let $limit814 = $len(list3)
                for (let i = 1; i <= $limit814; i += 1) {
                    table.insert(self.drop_adjust_test_group[k], tonumber(list3[i]))
                }
            }
        } else if (key === "drop_adjust_index") {
            let list = string.split(value, ",")
            let $limit818 = $len(list)
            for (let i = 1; i <= $limit818; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = tonumber(list2[1])
                let value = tonumber(list2[2])
                self.drop_adjust_index[list2[1]] = value
                if (key === 0) {
                    DASchemeConfig.Scheme_Week.priority = value
                } else if (key === 1) {
                    DASchemeConfig.Scheme_Normal.priority = value
                } else if (key === 2) {
                    DASchemeConfig.Scheme_Strong.priority = value
                } else if (key === 3) {
                    DASchemeConfig.Scheme_fuuu.priority = value
                }
            }
            //----------------------------------------以下是202206新掉落干预新增字段------------------------------------------
        } else if (key === "drop_adjust_percent_weak_new") {
            self.drop_adjust_percent_weak_new = tonumber(value)
        } else if (key === "drop_adjust_single_mn_weak_new") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_weak_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_weak_new") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_weak_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_percent_normal_new") {
            self.drop_adjust_percent_normal_new = tonumber(value)
        } else if (key === "drop_adjust_single_mn_normal_new") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_normal_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_normal_new") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_normal_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_percent_strong_new") {
            self.drop_adjust_percent_strong_new = tonumber(value)
        } else if (key === "drop_adjust_single_mn_strong_new") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_strong_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_strong_new") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_strong_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_percent_extreme_new") {
            self.drop_adjust_percent_extreme_new = tonumber(value)
        } else if (key === "drop_adjust_single_mn_extreme_new") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_extreme_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_extreme_new") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_extreme_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_percent_fuuu_new") {
            self.drop_adjust_percent_fuuu_new = tonumber(value)
        } else if (key === "drop_adjust_single_mn_fuuu_new") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_new") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_percent_new") {
            self.target_complete_expect_percent_new = tonumber(value)
        } else if (key === "fuuu_stop_left_steps_new") {
            self.fuuu_stop_left_steps_new = tonumber(value)
        } else if (key === "fuuu_stop_target_num_new") {
            let list = string.split(value, ",")
            let $limit908 = $len(list)
            for (let i = 1; i <= $limit908; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num_new[key] = tonumber(list2[2])
            }
        } else if (key === "drop_adjust_single_mn_fuuu_new") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_new") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_percent_new") {
            self.target_complete_expect_percent_new = tonumber(value)
        } else if (key === "fuuu_stop_left_steps_new") {
            self.fuuu_stop_left_steps_new = tonumber(value)
        } else if (key === "fuuu_stop_target_num_new") {
            let list = string.split(value, ",")
            let $limit954 = $len(list)
            for (let i = 1; i <= $limit954; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num_new[key] = tonumber(list2[2])
            }
        } else if (key === "drop_adjust_percent_fuuu_strong_new") {
            self.drop_adjust_percent_fuuu_strong_new = tonumber(value)
        } else if (key === "drop_adjust_single_mn_fuuu_strong_new") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_strong_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_strong_new") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_strong_new = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_percent_strong_new") {
            self.target_complete_expect_percent_strong_new = tonumber(value)
        } else if (key === "fuuu_stop_left_steps_strong_new") {
            self.fuuu_stop_left_steps_strong_new = tonumber(value)
        } else if (key === "fuuu_stop_target_num_strong_new") {
            self.fuuu_stop_target_num_strong_new = {}
            let list = string.split(value, ",")
            let $limit924 = $len(list)
            for (let i = 1; i <= $limit924; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num_strong_new[key] = tonumber(list2[2])
            }
        } else if (key === "drop_adjust_index_new") {
            self.drop_adjust_index_new = {}
            let list = string.split(value, ",")
            // console.log("【掉落配置】 drop_adjust_index_new list ",list)
            let $limit930 = $len(list)
            for (let i = 1; i <= $limit930; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = tonumber(list2[1])
                let value = tonumber(list2[2])
                self.drop_adjust_index_new[list2[1]] = value
            }
        } else if (key === "active_7daysTag_duration_new") {
            self.active_7daysTag_duration_new = tonumber(value)
        } else if (key === "active_30daysTag_duration_new") {
            self.active_30daysTag_duration_new = tonumber(value)
        } else if (key === "drop_adjust_percent_fuuu_counterV2") {
            self.drop_adjust_percent_fuuu_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_single_mn_fuuu_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_percent_counterV2") {
            self.target_complete_expect_percent_counterV2 = tonumber(value)
        } else if (key === "target_complete_expect_k_counterV2") {
            self.target_complete_expect_k_counterV2 = tonumber(value)
        } else if (key === "fuuu_stop_target_num_counterV2") {
            let list = string.split(value, ",")
            let $limit939 = $len(list)
            for (let i = 1; i <= $limit939; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_completion_counterV2") {
            let list = string.split(value, ",")
            let $limit945 = $len(list)
            for (let i = 1; i <= $limit945; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_completion_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_stop_left_steps_counterV2") {
            self.fuuu_stop_left_steps_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_percent_fuuu_strong_counterV2") {
            self.drop_adjust_percent_fuuu_strong_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_single_mn_fuuu_strong_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_strong_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_strong_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_strong_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_percent_strong_counterV2") {
            self.target_complete_expect_percent_strong_counterV2 = tonumber(value)
        } else if (key === "target_complete_expect_k_strong_counterV2") {
            self.target_complete_expect_k_strong_counterV2 = tonumber(value)
        } else if (key === "fuuu_stop_target_num_strong_counterV2") {
            self.fuuu_stop_target_num_strong_counterV2 = {}
            let list = string.split(value, ",")
            // console.log("【掉落配置】 fuuu_stop_target_num_strong_counterV2 list ",list)
            let $limit953 = $len(list)
            for (let i = 1; i <= $limit953; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num_strong_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_completion_strong_counterV2") {
            let list = string.split(value, ",")
              // console.log("【掉落配置】 fuuu_completion_strong_counterV2 list ",list)
            self.fuuu_completion_strong_counterV2 = {}
            let $limit959 = $len(list)
            for (let i = 1; i <= $limit959; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_completion_strong_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_stop_left_steps_strong_counterV2") {
            self.fuuu_stop_left_steps_strong_counterV2 = tonumber(value)
        } else if (key === "mainLevel_retry_dataNum") {
            self.mainLevel_retry_dataNum = tonumber(value)
        } else if (key === "adventureLevel_dataNum") {
            self.adv_level_dataNum = tonumber(value)
        } else if (key === "shipLevel_dataNum") {
            self.ship_level_dataNum = tonumber(value)
        } else if (key === "drop_adjust_percent_fuuu_negative_counterV2") {
            self.drop_adjust_percent_fuuu_negative_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_single_mn_fuuu_negative_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_negative_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_negative_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_negative_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_k_negative_counterV2") {
            self.target_complete_expect_k_negative_counterV2 = tonumber(value)
        } else if (key === "fuuu_stop_target_num_negative_counterV2") {
            let list = string.split(value, ",")
            let $limit1005 = $len(list)
            for (let i = 1; i <= $limit1005; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num_negative_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_completion_negative_counterV2") {
            let list = string.split(value, ",")
            let $limit1011 = $len(list)
            for (let i = 1; i <= $limit1011; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_completion_negative_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_stop_left_steps_negative_counterV2") {
            self.fuuu_stop_left_steps_negative_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_percent_fuuu_balance1_counterV2") {
            self.drop_adjust_percent_fuuu_balance1_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_single_mn_fuuu_balance1_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_balance1_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_balance1_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_balance1_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_k_balance1_start_counterV2") {
            self.target_complete_expect_k_balance1_start_counterV2 = tonumber(value)
        } else if (key === "target_complete_expect_k_balance1_end_counterV2") {
            self.target_complete_expect_k_balance1_end_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_percent_fuuu_balance2_counterV2") {
            self.drop_adjust_percent_fuuu_balance2_counterV2 = tonumber(value)
        } else if (key === "drop_adjust_single_mn_fuuu_balance2_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_single_mn_fuuu_balance2_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "drop_adjust_fullscreen_mn_fuuu_balance2_counterV2") {
            let list = string.split(value, ",")
            self.drop_adjust_fullscreen_mn_fuuu_balance2_counterV2 = table([1, "m", tonumber(list[1])], [1, "n", tonumber(list[2])])
        } else if (key === "target_complete_expect_k_balance2_start_counterV2") {
            self.target_complete_expect_k_balance2_start_counterV2 = tonumber(value)
        } else if (key === "target_complete_expect_k_balance2_end_counterV2") {
            self.target_complete_expect_k_balance2_end_counterV2 = tonumber(value)
        } else if (key === "fuuu_stop_target_num_balance_counterV2") {
            let list = string.split(value, ",")
            let $limit1021 = $len(list)
            for (let i = 1; i <= $limit1021; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_stop_target_num_balance_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_completion_balance_counterV2") {
            let list = string.split(value, ",")
            let $limit1027 = $len(list)
            for (let i = 1; i <= $limit1027; i += 1) {
                let list2 = string.split(list[i], ":")
                let key = list2[1]
                self.fuuu_completion_balance_counterV2[key] = tonumber(list2[2])
            }
        } else if (key === "fuuu_stop_left_steps_balance_counterV2") {
            self.fuuu_stop_left_steps_balance_counterV2 = tonumber(value)
        }


    }
    self.DASchemeConfig = DASchemeConfig
    // console.log("【掉落配置】v1的DASchemeConfig", $tableToObj(self.DASchemeConfig))
}

// 掉落优化配置切换到202206的新配置，会用新配置覆盖掉之前的
DropAdjustMetaRef.prototype.changeToV2 = function () {
    let self = this
    let DASchemeConfig = require("clover/config/userTag/DASchemeConfig")
    DASchemeConfig.Scheme_Week.probability = self.drop_adjust_percent_weak_new
    DASchemeConfig.Scheme_Week.dropPort.single = self.drop_adjust_single_mn_weak_new
    DASchemeConfig.Scheme_Week.dropPort.global = self.drop_adjust_fullscreen_mn_weak_new
    DASchemeConfig.Scheme_Normal.probability = self.drop_adjust_percent_normal_new
    DASchemeConfig.Scheme_Normal.dropPort.single = self.drop_adjust_single_mn_normal_new
    DASchemeConfig.Scheme_Normal.dropPort.global = self.drop_adjust_fullscreen_mn_normal_new
    DASchemeConfig.Scheme_Strong.probability = self.drop_adjust_percent_strong_new
    DASchemeConfig.Scheme_Strong.dropPort.single = self.drop_adjust_single_mn_strong_new
    DASchemeConfig.Scheme_Strong.dropPort.global = self.drop_adjust_fullscreen_mn_strong_new
    DASchemeConfig.Scheme_Extreme.probability = self.drop_adjust_percent_extreme_new
    DASchemeConfig.Scheme_Extreme.dropPort.single = self.drop_adjust_single_mn_extreme_new
    DASchemeConfig.Scheme_Extreme.dropPort.global = self.drop_adjust_fullscreen_mn_extreme_new
    DASchemeConfig.Scheme_fuuu.probability = self.drop_adjust_percent_fuuu_new
    DASchemeConfig.Scheme_fuuu.dropPort.single = self.drop_adjust_single_mn_fuuu_new
    DASchemeConfig.Scheme_fuuu.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu_new
    DASchemeConfig.Scheme_fuuu.fuuu.expectRatio = self.target_complete_expect_percent_new
    DASchemeConfig.Scheme_fuuu.fuuu.stopLeftSteps = self.fuuu_stop_left_steps_new
    for (let k in self.fuuu_stop_target_num_new) {
        let v = self.fuuu_stop_target_num_new[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu.fuuu.stopTargetNum[k] = v
    }
    // fuuu强
    DASchemeConfig.Scheme_fuuu_strong.probability = self.drop_adjust_percent_fuuu_strong_new
    DASchemeConfig.Scheme_fuuu_strong.dropPort.single = self.drop_adjust_single_mn_fuuu_strong_new
    DASchemeConfig.Scheme_fuuu_strong.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu_strong_new
    DASchemeConfig.Scheme_fuuu_strong.fuuu.expectRatio = self.target_complete_expect_percent_strong_new
    DASchemeConfig.Scheme_fuuu_strong.fuuu.stopLeftSteps = self.fuuu_stop_left_steps_strong_new
    for (let k in self.fuuu_stop_target_num_strong_new) {
        let v = self.fuuu_stop_target_num_strong_new[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_strong.fuuu.stopTargetNum[k] = v
    }
    // fuuu弱 计数V2
    DASchemeConfig.Scheme_fuuu_counterV2.probability = self.drop_adjust_percent_fuuu_counterV2
    DASchemeConfig.Scheme_fuuu_counterV2.dropPort.single = self.drop_adjust_single_mn_fuuu_counterV2
    DASchemeConfig.Scheme_fuuu_counterV2.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu_counterV2
    DASchemeConfig.Scheme_fuuu_counterV2.fuuu.expectRatio = 1
    DASchemeConfig.Scheme_fuuu_counterV2.fuuu.stopLeftSteps = self.fuuu_stop_left_steps_counterV2
    DASchemeConfig.Scheme_fuuu_counterV2.fuuu.reduceExpectNum = self.target_complete_expect_k_counterV2
    for (let k in self.fuuu_stop_target_num_counterV2) {
        let v = self.fuuu_stop_target_num_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_counterV2.fuuu.stopTargetNum[k] = v
    }
    for (let k in self.fuuu_completion_counterV2) {
        let v = self.fuuu_completion_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_counterV2.fuuu.reduceNum[k] = v
    }
    // fuuu强 计数V2
    DASchemeConfig.Scheme_fuuu_strong_counterV2.probability = self.drop_adjust_percent_fuuu_strong_counterV2
    DASchemeConfig.Scheme_fuuu_strong_counterV2.dropPort.single = self.drop_adjust_single_mn_fuuu_strong_counterV2
    DASchemeConfig.Scheme_fuuu_strong_counterV2.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu_strong_counterV2
    DASchemeConfig.Scheme_fuuu_strong_counterV2.fuuu.expectRatio = 1
    DASchemeConfig.Scheme_fuuu_strong_counterV2.fuuu.stopLeftSteps = self.fuuu_stop_left_steps_strong_counterV2
    DASchemeConfig.Scheme_fuuu_strong_counterV2.fuuu.reduceExpectNum = self.target_complete_expect_k_strong_counterV2
    for (let k in self.fuuu_stop_target_num_strong_counterV2) {
        let v = self.fuuu_stop_target_num_strong_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_strong_counterV2.fuuu.stopTargetNum[k] = v
    }
    for (let k in self.fuuu_completion_strong_counterV2) {
        let v = self.fuuu_completion_strong_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_strong_counterV2.fuuu.reduceNum[k] = v
    }
    //-------------------------------新增负向和夹子begin-------------------------------------------------------------------------
    //fuuu反向
    DASchemeConfig.Scheme_fuuu_negative.probability = self.drop_adjust_percent_fuuu_negative_counterV2
    DASchemeConfig.Scheme_fuuu_negative.dropPort.single = self.drop_adjust_single_mn_fuuu_negative_counterV2
    DASchemeConfig.Scheme_fuuu_negative.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu_negative_counterV2
    DASchemeConfig.Scheme_fuuu_negative.fuuu.expectRatio = 1
    DASchemeConfig.Scheme_fuuu_negative.fuuu.reduceExpectNum = self.target_complete_expect_k_negative_counterV2
    DASchemeConfig.Scheme_fuuu_negative.fuuu.stopLeftSteps = self.fuuu_stop_left_steps_negative_counterV2
    for (let k in self.fuuu_stop_target_num_negative_counterV2) {
        let v = self.fuuu_stop_target_num_negative_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_negative.fuuu.stopTargetNum[k] = v
    }
    for (let k in self.fuuu_completion_negative_counterV2) {
        let v = self.fuuu_completion_negative_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_negative.fuuu.reduceNum[k] = v
    }
    //fuuu夹子
    //夹子negative
    DASchemeConfig.Scheme_fuuu_balance.negative.probability = self.drop_adjust_percent_fuuu_balance1_counterV2
    DASchemeConfig.Scheme_fuuu_balance.negative.dropPort.single = self.drop_adjust_single_mn_fuuu_balance1_counterV2
    DASchemeConfig.Scheme_fuuu_balance.negative.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu_balance1_counterV2
    DASchemeConfig.Scheme_fuuu_balance.negative.reduceExpectNum = self.target_complete_expect_k_balance1_start_counterV2
    DASchemeConfig.Scheme_fuuu_balance.negative.finishReduceExpectNum = self.target_complete_expect_k_balance1_end_counterV2
    DASchemeConfig.Scheme_fuuu_balance.positive.probability = self.drop_adjust_percent_fuuu_balance2_counterV2
    DASchemeConfig.Scheme_fuuu_balance.positive.dropPort.single = self.drop_adjust_single_mn_fuuu_balance2_counterV2
    DASchemeConfig.Scheme_fuuu_balance.positive.dropPort.global = self.drop_adjust_fullscreen_mn_fuuu_balance2_counterV2
    DASchemeConfig.Scheme_fuuu_balance.positive.reduceExpectNum = self.target_complete_expect_k_balance2_start_counterV2
    DASchemeConfig.Scheme_fuuu_balance.positive.finishReduceExpectNum = self.target_complete_expect_k_balance2_end_counterV2
    DASchemeConfig.Scheme_fuuu_balance.fuuu.expectRatio = 1
    for (let k in self.fuuu_stop_target_num_balance_counterV2) {
        let v = self.fuuu_stop_target_num_balance_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_balance.fuuu.stopTargetNum[k] = v
    }
    for (let k in self.fuuu_completion_balance_counterV2) {
        let v = self.fuuu_completion_balance_counterV2[k]
        if ($null(v)) continue
        DASchemeConfig.Scheme_fuuu_balance.fuuu.reduceNum[k] = v
    }
    DASchemeConfig.Scheme_fuuu_balance.fuuu.stopLeftSteps = self.fuuu_stop_left_steps_balance_counterV2
    for (let k in self.drop_adjust_index_new) {
        let v = self.drop_adjust_index_new[k]
        if ($null(v)) continue
        if (k === 0) {
            DASchemeConfig.Scheme_Week.priority = v
        } else if (k === 1) {
            DASchemeConfig.Scheme_Normal.priority = v
        } else if (k === 2) {
            DASchemeConfig.Scheme_Strong.priority = v
        } else if (k === 3) {
            DASchemeConfig.Scheme_fuuu.priority = v
        } else if (k === 4) {
            DASchemeConfig.Scheme_Extreme.priority = v
        } else if (k === 5) {
            DASchemeConfig.Scheme_fuuu_strong.priority = v
        }
    }
    // cc.log("【掉落配置】转换成v2的DASchemeConfig", $tableToObj(DASchemeConfig))
    // cc.log("【掉落优化】" + table.tostring(DASchemeConfig.Scheme_fuuu_strong))
    // cc.log("【掉落优化】" + table.tostring(DASchemeConfig.Scheme_fuuu_counterV2))
    // cc.log("【掉落优化】" + table.tostring(DASchemeConfig.Scheme_fuuu_strong_counterV2))
}

// 202206掉落干预的掉落优化方案配置
DropAdjustPlanV2MetaRef = xClass("DropAdjustPlanV2MetaRef", MetaRef)
DropAdjustPlanV2MetaRef.prototype.ctor = function () {
    let self = this
    self.configs = table()
    self.cubeGroups = table()
}
DropAdjustPlanV2MetaRef.prototype.fromLua = function (src) {
    let self = this
    // let maxLevel = MetaManager.getInstance().global.max_level
    let maxLevel = UserManager.getInstance().getMaxLevelServer()
    for (let _ = 1, def = src[1]; def; _++, def = src[_]) {
        let item = table()
        for (let key in def) {
            let value = def[key]
            if ($null(value)) continue
            if (key === "id") {
                item.id = tonumber(value)
            } else if (key === "test_mutex") {
                item.test_mutex = tonumber(value)
            } else if (key === "cd_group") {
                item.cd_group = tonumber(value)
            } else if (key === "test_id") {
                item.cube_test_id = value
            } else if (key === "test_switch") {
                item.cube_test_switch = string.split(value, ";")
            } else if (key === "test_type") {
                item.test_type = tonumber(value)
            } else if (key === "test_cd") {
                // item.test_cd = tonumber(value) || 0
                // item.test_cd = string.split(value, ";")
                item.test_cd = value
            } else if (key === "test_priority") {
                item.test_priority = tonumber(value) || 0
            } else if (key === "platform_tag1") {
                // if (value != "all"){
                item.platform_tag1 = value
                // }
            } else if (key === "platform_tag2") {
                // if (value != "all"){
                item.platform_tag2 = value
                // }
            } else if (key === "pay_tag") {
                item.pay_tag = string.split(value, ";")
            } else if (key === "active_tag_7days") {
                item.active_tag_7days = table()
                if (value === "-") {
                    // 本来是配-标识不需要判断此标签，这个现在不会有了
                    table.insert(item.active_tag_7days, table())
                } else {
                    let dayRanges = string.split(value, ";")
                    for (let k in dayRanges) {
                        let v = dayRanges[k]
                        if ($null(v)) continue
                        let range = string.split(v, ",")
                        if ($len(range) === 1) {
                            table.insert(item.active_tag_7days, table([1, "s", tonumber(range[1])], [1, "e", tonumber(range[1])]))
                        } else {
                            table.insert(item.active_tag_7days, table([1, "s", tonumber(range[1])], [1, "e", tonumber(range[2])]))
                        }
                    }
                }
            } else if (key === "active_tag_30days") {
                item.active_tag_30days = table()
                if (value === "-") {
                    // 本来是配-标识不需要判断此标签，这个现在不会有了
                    table.insert(item.active_tag_30days, table())
                } else {
                    let dayRanges = string.split(value, ";")
                    for (let k in dayRanges) {
                        let v = dayRanges[k]
                        if ($null(v)) continue
                        let range = string.split(v, ",")
                        if ($len(range) === 1) {
                            table.insert(item.active_tag_30days, table([1, "s", tonumber(range[1])], [1, "e", tonumber(range[1])]))
                        } else {
                            table.insert(item.active_tag_30days, table([1, "s", tonumber(range[1])], [1, "e", tonumber(range[2])]))
                        }
                    }
                }
            } else if (key === "level_tag") {
                item.level_tag = table()
                let levelRanges = string.split(value, ";")
                for (let k in levelRanges) {
                    let v = levelRanges[k]
                    if ($null(v)) continue
                    let range = string.split(v, ",")
                    let $limit1039 = $len(range)
                    for (let i = 1; i <= $limit1039; i += 1) {
                        // if (string.find(range[i], "max")) {
                        if (range[i].indexOf("max") >= 0){ 
                            // let evalStr = "return " + string.gsub(range[i], "max", tostring(maxLevel))
                            let evalStr = range[i].replace("max",maxLevel)
                            let arr = evalStr.split("-")
                            // console.log("【掉落配置】 parseDropAdjustConfigV2 item.evalStr", range[i],evalStr)
                            // range[i] = loadstring(evalStr)()
                            if (arr.length > 1){
                                range[i] = maxLevel - arr[1]
                            }else{
                                range[i] = maxLevel
                            }
                            // console.log("【掉落配置】 parseDropAdjustConfigV2 range[i]", range[i],evalStr)

                        }
                    }
                    if ($len(range) === 1) {
                        table.insert(item.level_tag, table([1, "s", tonumber(range[1])], [1, "e", tonumber(range[1])]))
                    } else {
                        table.insert(item.level_tag, table([1, "s", tonumber(range[1])], [1, "e", tonumber(range[2])]))
                    }
                }
            } else if (key === "difficulty_tag") {
                let strs = string.split(value, ";")
                item.difficulty_tag = table()
                for (let i = 1, v = strs[1]; v; i++, v = strs[i]) {
                    table.insert(item.difficulty_tag, tonumber(v))
                }
            } else if (key === "win_range_prebird") {
                item.win_range_prebird = table()
                let strs = string.split(value, ",")
                if ($len(strs) === 2) {
                    item.win_range_prebird.min = tonumber(strs[1])
                    item.win_range_prebird.max = tonumber(strs[2])
                } else {
                    item.win_range_prebird.min = tonumber(value)
                    item.win_range_prebird.max = item.win_range_prebird.min
                }
            } else if (key === "win_range_withbird") {
                item.win_range_withbird = table()
                let strs = string.split(value, ",")
                if ($len(strs) === 2) {
                    item.win_range_withbird.min = tonumber(strs[1])
                    item.win_range_withbird.max = tonumber(strs[2])
                } else {
                    item.win_range_withbird.min = tonumber(value)
                    item.win_range_withbird.max = item.win_range_withbird.min
                }
            } else if (key === "consume") {
                let consumeInfo = string.split(value, "|")
                if ($len(consumeInfo) === 2) {
                    let consumeRangeInfo = string.split(consumeInfo[2], ",")
                    item.consume = table(
                        [1, "level", tonumber(consumeInfo[1])],
                        [1, "min", tonumber(consumeRangeInfo[1])],
                        [1, "max", tonumber(consumeRangeInfo[2])]
                    )
                } else {
                    item.consume = table([1, "level", -1])
                }
            } else if (key === "test_strategy1") {
                item.test_strategy1 = tonumber(value)
            } else if (key === "test_strategy2") {
                item.test_strategy2 = tonumber(value)
            } else if (key === "test_strategy3") {
                item.test_strategy3 = tonumber(value)
            } else if (key === "test_para1") {
                item.test_para1 = value
            } else if (key === "test_para2") {
                item.test_para2 = value
            } else if (key === "test_para3") {
                item.test_para3 = value
            } else if (key === "test_para4") {
                item.test_para4 = value
            } else if (key === "test_para5") {
                item.test_para5 = value
            } else if (key === "test_para6") {
                item.test_para6 = value
            } else if (key === "test_para7") {
                item.test_para7 = value
            } else if (key === "test_para8") {
                item.test_para8 = value
            } else if (key === "test_para9") {
                item.test_para9 = value
            }
        }
        if (!self.configs[item.test_mutex]) {
            self.configs[item.test_mutex] = table()
        }
        // console.log("【掉落配置】 parseDropAdjustConfigV2 item.test_mutex", item.test_mutex,item)
        table.insert(self.configs[item.test_mutex], item)
        if (self.cubeGroups[item.cube_test_id] == null && !string.isEmpty(item.cube_test_id)) {
            self.cubeGroups[item.cube_test_id] = true
        }
    }
    CfgManager.release("drop_intervention");
    // console.log("【掉落配置】 parseDropAdjustConfigV2 dropAdjustPlanV2", self.dropAdjustPlanV2)
}
DropAdjustPlanV2MetaRef.prototype.getPlanConfig = function (planId) {
    let self = this
    for (let _ in self.configs) {
        let configs = self.configs[_]
        if ($null(configs)) continue
        for (let k in configs) {
            let v = configs[k]
            if ($null(v)) continue
            if (v && v.id === planId) {
                // WARN: maybe multi result
                return table.clone(v)
            }
        }
    }
}

// 202206掉落干预的掉落优化关卡难度标签配置
DropAdjustDiffTagV2MetaRef = xClass("DropAdjustDiffTagV2MetaRef", MetaRef)
DropAdjustDiffTagV2MetaRef.prototype.ctor = function () {
    let self = this
    self.configs = table()
}
DropAdjustDiffTagV2MetaRef.prototype.fromLua = function (src) {
    let self = this
    let maxLevel = UserManager.getInstance().getMaxLevelServer()
    for (let _ = 1, def = src[1]; def; _++, def = src[_]) {
        let item = table()
        let startLevel = null
        let endLevel = null
        let level_range = 1
        for (let key in def) {
            let value = def[key]
            if ($null(value)) continue
            if (key === "id") {
                item.id = tonumber(value)
            } else if (key === "start_level") {
                if (value.indexOf("max") >= 0){ 
                    let evalStr = value.replace("max", maxLevel)
                    let arr = evalStr.split("-")
                    if (arr.length > 1){
                        value = maxLevel - arr[1]
                    }else{
                        value = maxLevel
                    }
                }
                startLevel = tonumber(value)
            } else if (key === "end_level") {
                if (value.indexOf("max") >= 0){ 
                    let evalStr = value.replace("max", maxLevel)
                    let arr = evalStr.split("-")
                    if (arr.length > 1){
                        value = maxLevel - arr[1]
                    }else{
                        value = maxLevel
                    }
                }
                endLevel = tonumber(value)
            } else if (key === "level_range") {
                level_range = tonumber(value)
            } else if (key === "tag_1_formula") {
                item.tag_1_formula = value
            } else if (key === "tag_2_formula") {
                item.tag_2_formula = value
            } else if (key === "tag_3_formula") {
                item.tag_3_formula = value
            } else if (key === "tag_4_formula") {
                item.tag_4_formula = value
            } else if (key === "tag_5_formula") {
                item.tag_5_formula = value
            }
        }
        if (startLevel) {
            let config = table(
                [1, "startLevel", startLevel],
                [1, "endLevel", endLevel],
                [1, "level_range", level_range],
                [1, "items", table()]
            )
            table.insert(self.configs, config)
        }
        let config = self.configs[$len(self.configs)]
        table.insert(config.items, item)
    }
    // console.log("DropAdjustDiffTagV2MetaRef self.configs ",self.configs)
}

// 掉落优化关卡难度标签配置
DropAdjustDiffTagMetaRef = xClass("DropAdjustDiffTagMetaRef", MetaRef)
DropAdjustDiffTagMetaRef.prototype.ctor = function () {
    let self = this
    self.configs = table()
}
DropAdjustDiffTagMetaRef.prototype.fromLua = function (src) {
    let self = this
    for (let _ = 1, cfg = src[1]; cfg; _++, cfg = src[_]) {
        let l = $len(self.configs);
        let item = {
                        "diff_range": cfg.diff_range, 
                        "tag_0_formula": cfg.tag_0_formula, 
                        "tag_1_formula": cfg.tag_1_formula, 
                        "tag_2_formula": cfg.tag_2_formula, 
                        "tag_3_formula": cfg.tag_3_formula
                    };
        if (l == 0){

        }else{
            let start0 = self.configs[l].start_level;
            let end0 = self.configs[l].end_level;
            let start1 = cfg.start_level;
            let end1 = cfg.end_level;
            // console.log("【掉落配置】 start0 ", start0,start1,end0,end1)

            if (start0 == start1 && end0 == end1){
                table.insert(self.configs[l]["items"], item);
                continue;
            }
        }
        cfg.startLevel = cfg.start_level
        cfg.endLevel = cfg.end_level

        table.insert(self.configs, cfg);
        l = $len(self.configs);
        self.configs[l]["items"] = table();
        table.insert(self.configs[l]["items"], item);
    }
    console.log("DropAdjustDiffTagMetaRef self.configs ",self.configs)

}


//关内道具消耗价值(通用 非超鸟专用)
PropConsumeValueMeta = xClass("PropConsumeValueMeta", MetaRef)
PropConsumeValueMeta.prototype.ctor = function () {
    let self = this
    self.propConsumeValueList = table()
}
PropConsumeValueMeta.prototype.fromLua = function (src) {
    let self = this
    if (src === null) {
        return 
    }
    for (const key in src) {
        self.propConsumeValueList[key] = src[key].consume_value
    }
    // for (let _ = 1, def = src[1]; def; _++, def = src[_]) {
    //     let propId
    //     let consumeValue
    //     for (let key in def) {
    //         let value = def[key]
    //         if ($null(value)) continue
    //         if (key === "id") {
    //             propId = tonumber(value)
    //         } else if (key === "consume_value") {
    //             consumeValue = tonumber(value)
    //         }
    //     }
    //     if (propId !== null && consumeValue !== null) {
    //         self.propConsumeValueList[propId] = consumeValue
    //     }
    // }
}